import React from 'react';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

export interface IGridCellCheckbox {
  params: any;
}
const GridCellCheckbox = (props: IGridCellCheckbox) => {
  const { params } = props;
  const api = useGridApiContext();

  const handleClick = () => {
    const isEditable = api.current.isCellEditable(params);
    if (isEditable) {
      api.current.startCellEditMode({ field: params.field, id: params.id });
      api.current.setEditCellValue({ field: params.field, id: params.id, value: !params.value, debounceMs: 10 });
    }
  };

  return (
    <div onClick={handleClick} style={{ alignItems: 'center' }}>
      {params.value ? (
        <CheckBoxIcon color="primary" />
      ) : (
        <CheckBoxOutlineBlankIcon sx={{ color: 'rgba(0, 0, 0, 0.6)' }} />
      )}
    </div>
  );
};

export default GridCellCheckbox;
